<template>
  <div>
    <div class="relative add-element-wrapper">
      <quill-editor
        class="text-sm"
        v-model="content"
        :options="getQuillEditorOptions('section-paragraph')"
        @ready="onEditorReady($event)"
        @change="onEditorChange($event)"
        @focus="onEditorFocus($event)"
      ></quill-editor>
      <div
        v-if="showToolbar"
        class="absolute flex space-x-3 w-full"
        v-bind:style="{ top: topPosition + 'px', left: -12 + 'px' }"
      >
        <div
          @click="toggleControls()"
          class="cursor-pointer absolute left-0 top-0 -ml-8"
        >
          <span v-if="showControls">
            <closeIcon />
          </span>
          <span v-else>
            <plusIcon />
          </span>
        </div>
        <div class="flex space-x-3" name="slide-fade" v-if="showControls">
          <div class="relative img-picker">
            <image-picker
              v-model="imageSrc"
              :primary="true"
              @change="imgUpload"
            ></image-picker>
            <div
              @click="
                () => {
                  currentElement = 'image';
                }
              "
              class="
                cursor-pointer
                overflow-hidden
                absolute
                top-0
                pointer-events-none
              "
            >
              <imageIcon />
            </div>
          </div>
          <div class="relative video-picker">
            <video-picker
              class="absolute left-0 top-0"
              :value="{ videoSrc: '', videoEmbed: '' }"
              @selected="videoUpload"
            ></video-picker>
            <div
              @click="
                () => {
                  (currentElement = 'video'), (showControls = false);
                }
              "
              class="cursor-pointer"
            >
              <videoIcon />
            </div>
          </div>
          <div
            @click="
              () => {
                (currentElement = 'embed'), (showControls = false);
              }
            "
            class="cursor-pointer"
          >
            <embedIcon />
          </div>
          <div @click="openButtonModal" class="cursor-pointer">
            <buttonIcon />
          </div>
        </div>
        <input
          class="w-full h-8 border-none ml-2"
          v-model="embededCode"
          placeholder="Paste the embed code and press Enter"
          v-if="currentElement === 'embed'"
          @keyup.enter="embedCode"
        />
      </div>
      <gd-modal
        :name="addElBtnCustomRef"
        title="Add new button"
        class="custom-modal"
        :ref="addElBtnCustomRef"
      >
        <VuePerfectScrollbar>
          <div class="scroll-modal">
            <div class="p-6">
              <div class="mb-6">
                <p class="text-dark text-sm font-semibold mb-2">Button Label</p>
                <text-input
                  v-model="buttonValue.text"
                  :validator="$v.buttonValue.text"
                  attribute="Text"
                  placeholder=""
                />
              </div>
              <div class="mb-6">
                <p class="text-dark text-sm font-semibold mb-2">Button Link</p>
                <text-input
                  v-model="buttonValue.link"
                  :validator="$v.buttonValue.link"
                  attribute="Link"
                  placeholder=""
                />
              </div>
              <div class="mb-6">
                <p class="text-dark text-sm font-semibold mb-2">
                  Button Alignment
                </p>
                <div
                  class="style-radio light"
                  v-for="(radioOption, index) in alignmentOptions"
                  :key="index"
                >
                  <gd-custom-radio
                    v-model="buttonClassValue"
                    :option="radioOption"
                  ></gd-custom-radio>
                </div>
              </div>
              <div class="mb-6" v-if="!buttonDefaultColour">
                <p class="text-dark text-sm font-semibold mb-2">
                  Button Text Color
                </p>
                <color-picker
                  v-model="buttonValue.textColor"
                  :colors="tailwindConfig.colors"
                  data-cy="buttonValue.textColor"
                  :cookies-origin="
                    `groovemember_membership_` + $route.params.id
                  "
                ></color-picker>
              </div>
              <div class="mb-6" v-if="!buttonDefaultColour">
                <p class="text-dark text-sm font-semibold mb-2">
                  Button Background Color
                </p>
                <color-picker
                  v-model="buttonValue.backgroundColor"
                  :colors="tailwindConfig.colors"
                  data-cy="buttonValue.backgroundColor"
                  :cookies-origin="
                    `groovemember_membership_` + $route.params.id
                  "
                ></color-picker>
              </div>
              <div class="mb-6">
                <p class="text-dark text-sm font-semibold mb-2">
                  Default Button Theme
                </p>
                <gd-toggle dark v-model="buttonDefaultColour" />
              </div>
              <div class="mb-6">
                <p class="text-dark text-sm font-semibold mb-2">
                  Open in New Tab
                </p>
                <gd-toggle dark v-model="buttonTargetValue" />
              </div>

              <div class="flex flex-row w-full mt-4 justify-center">
                <gd-button
                  class="text-center h-10 border-grey-1"
                  size="large"
                  @click="closeButtonModal"
                  >Cancel</gd-button
                >
                <gd-button
                  class="text-center h-10 ml-4"
                  size="large"
                  primary
                  @click="addButton"
                  >Done</gd-button
                >
              </div>
            </div>
          </div>
        </VuePerfectScrollbar>
      </gd-modal>
      <div class="hidden-elements">
        <video-picker
          ref="videoPicker"
          class="absolute left-0 top-0"
          :value="{ videoSrc: '', videoEmbed: '' }"
          @selected="videoEdit"
        ></video-picker>
        <gd-modal
          ref="editImageModal"
          name="editImageModal"
          width="100%"
          height="100%"
        >
          <image-picker-without-modal
            :value="imageSrc"
            modal="true"
            remove="false"
            @close-modal="$refs.editImageModal.close()"
            @selected="editImage"
          ></image-picker-without-modal>
        </gd-modal>
      </div>
    </div>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import ImagePicker from '@groovepages/gd-ui-kit/components/ImagePickerModal';
import VideoPicker from '@groovepages/gd-ui-kit/components/video-library/VideoLibrary';
import GdButton from '@groovepages/gd-ui-kit/components/Button';
import GdToggle from '@groovepages/gd-ui-kit/components/Toggle';
//import ColorPicker from '@groovepages/gd-ui-kit/components/ColorPicker';
import GdCustomRadio from '@groovepages/gd-ui-kit/components/GdCustomRadio';
import TextInput from '@groovepages/gd-ui-kit/components/TextInput';
import GdModal from '@groovepages/gd-ui-kit/components/Modal';
import '../../../blots/embed';
import '../../../blots/wistiaEmbed';
import '../../../blots/button';
import '../../../blots/image';
import '../../../blots/video';
import '../../../blots/deleteButton';
import shortId from 'shortid';
import tailwindConfig from '@groovepages/gp-page-ui-kit/tailwind';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import plusIcon from '../../../../../assets/images/icons/round-plus.svg';
import closeIcon from '../../../../../assets/images/icons/round-close.svg';
import imageIcon from '../../../../../assets/images/icons/round-image.svg';
import videoIcon from '../../../../../assets/images/icons/round-video.svg';
import embedIcon from '../../../../../assets/images/icons/round-embed.svg';
import buttonIcon from '../../../../../assets/images/icons/round-button.svg';
import quillMixin from '../../../mixins/quill';
import ImagePickerWithoutModal from '@groovepages/gd-ui-kit/components/ImagePicker';

export default {
  name: 'AddElement',
  mixins: [quillMixin],
  data() {
    return {
      isEditButton: false,
      topPosition: 0,
      showControls: false,
      showToolbar: false,
      imageSrc: '',
      embededCode: '',
      currentElement: '',
      buttonValue: {
        text: 'New Button',
        link: 'https://app.groove.cm/',
        class: 'add-button align-left',
        backgroundColor: 'rgba(253, 100, 129, 1)',
        textColor: 'rgba(255, 255, 255, 1)',
        target: '_self',
        toggleon:true
      },
      alignmentOptions: [
        {
          id: 1,
          title: 'Left',
        },
        {
          id: 2,
          title: 'Right',
        },
        {
          id: 3,
          title: 'Center',
        },
      ],
      tailwindConfig,
      buttonTargetValue: false,
      buttonClassValue: 1,
      buttonDefaultColour:true,
    };
  },
  validations: {
    buttonValue: {
      text: {
        required,
      },
      link: {
        required,
      },
    },
  },
  components: {
    ImagePicker,
    VideoPicker,
    GdButton,
    GdToggle,
    // ColorPicker,
    GdCustomRadio,
    TextInput,
    GdModal,
    plusIcon,
    closeIcon,
    imageIcon,
    videoIcon,
    embedIcon,
    buttonIcon,
    VuePerfectScrollbar,
    ImagePickerWithoutModal,
  },
  props: {
    addElBtnCustomRef: {},
    callback: {
      required: true,
      type: Function,
    },
    html: {},
    getThemeSettings: {},
  },
  computed: {
    content: {
      get() {
        return this.html;
      },
      set(value) {
        this.callback(value);
      },
    },
    themeSettings() {
      return this.getThemeSettings();
    },
  },
  methods: {
    toggleControls() {
      this.showControls = !this.showControls;
      this.currentElement = '';
    },
    videoUpload(video) {
      if (!video.video_embed) return;

      if (video.video_embed.includes('fast.wistia.com')) {
        this.embededCode = video.video_embed;
        this.wistiaEmbedCode();
        return;
      }

      const randomId = shortId.generate();
      const range = this.quillInstance.getSelection(true);

      this.quillInstance.insertEmbed(range.index, 'addVideo', {
        videoSrc: video.video_source,
        videoEmbed: video.video_embed,
        shortId: randomId,
      });

      this.quillInstance.setSelection(range.index + 1, true);
      this.currentElement = '';
    },
    videoEdit(video) {
      if (!video.video_embed) return;
      const randomId = shortId.generate();
      const range = this.quillInstance.getSelection(true);

      this.quillInstance.deleteText(range.index, 1);
      this.quillInstance.insertEmbed(range.index, 'addVideo', {
        videoSrc: video.video_source,
        videoEmbed: video.video_embed,
        shortId: randomId,
      });

      this.quillInstance.setSelection(range.index, true);
      return;
    },
    imgUpload(filename) {
      if (typeof filename === 'string') {
        const randomId = shortId.generate();
        const range = this.quillInstance.getSelection(true);
        this.quillInstance.insertEmbed(range.index, 'image', this.imageSrc);
        this.quillInstance.insertText(range.index + 1, " ", true);
        this.quillInstance.setSelection(range.index + 1, true);
      }
      this.currentElement = '';
    },
    editImage(filename) {
      if (typeof filename === 'string') {
        const randomId = shortId.generate();
        const range = this.quillInstance.getSelection(true);
        this.quillInstance.deleteText(range.index, 1);
        this.quillInstance.insertEmbed(range.index, 'image', filename);
        this.quillInstance.insertText(range.index + 1, " ", true);
        this.quillInstance.setSelection(range.index + 1, true);
        return;
      }
    },
    embedCode() {
      const randomId = shortId.generate();
      const range = this.quillInstance.getSelection(true);

      this.quillInstance.insertEmbed(range.index, 'embedElement', {
        value: this.embededCode,
        shortId: randomId,
      });

      this.quillInstance.insertEmbed(range.index, 'deleteButton', {
        value: '',
        shortId: randomId,
      });

      this.quillInstance.setSelection(range.index + 1, true);
      this.showButtons = false;
      setTimeout(() => {
        this.showToolbar = false;
      }, 200);
      setTimeout(() => {
        this.embededCode = '';
        this.currentElement = '';
      }, 3000);
    },
    wistiaEmbedCode() {
      const randomId = shortId.generate();
      const range = this.quillInstance.getSelection(true);

      this.quillInstance.insertEmbed(range.index, 'wistiaEmbed', {
        value: this.embededCode,
        shortId: randomId,
      });

      this.quillInstance.insertEmbed(range.index, 'deleteButton', {
        value: '',
        shortId: randomId,
      });

      this.quillInstance.setSelection(range.index + 1, true);
      this.showButtons = false;
      setTimeout(() => {
        this.showToolbar = false;
      }, 200);
      setTimeout(() => {
        this.embededCode = '';
        this.currentElement = '';
      }, 3000);
    },
    openButtonModal() {
      this.buttonValue = {
        text: 'New Button',
        link: 'https://app.groove.cm/',
        class: 'add-button align-left',
        backgroundColor: this.themeSettings.button_section.bg_color,
        textColor: this.themeSettings.button_section.text_color,
        target: '_self',
        toggleon:true
     };
      this.buttonDefaultColour=true;
      this.buttonTargetValue = false;
      this.buttonClassValue = 1;
      this.$refs[this.addElBtnCustomRef].open();
    },
    ButtonAlign() {
      if (this.buttonValue.buttonClassValue.includes('left')) {
        this.buttonClassValue = 1;
      } else if (this.buttonValue.buttonClassValue.includes('right')) {
        this.buttonClassValue = 2;
      } else if (this.buttonValue.buttonClassValue.includes('center')) {
        this.buttonClassValue = 3;
      }
    },
    closeButtonModal() {
      this.$refs[this.addElBtnCustomRef].close();
      this.ButtonEdit = false;
    },
    addButton() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$v.$reset();
        const randomId = shortId.generate();
        this.buttonValue.shortId = randomId;
        const range = this.quillInstance.getSelection(true);
        if (this.isEditButton) {
          this.isEditButton = false;
          this.quillInstance.deleteText(range.index, 1);
        }
        this.buttonValue.toggleon=this.buttonDefaultColour?true:false;
        this.buttonValue.backgroundColor=this.buttonDefaultColour?'rgba(253, 100, 129, 1)':this.buttonValue.backgroundColor;
        this.buttonValue.textColor=this.buttonDefaultColour?'rgba(255, 255, 255, 1)':this.buttonValue.textColor;
        this.quillInstance.insertEmbed(
          range.index,
          'addButton',
          this.buttonValue
        );

        this.quillInstance.setSelection(range.index + 1, true);
        setTimeout(() => {
          this.showToolbar = false;
        }, 200);

        this.closeButtonModal();
      }
    },
  },
  watch: {
    buttonTargetValue(newValue, oldValue) {
      if (newValue) {
        this.buttonValue.target = '_blank';
      } else {
        this.buttonValue.target = '_self';
      }
    },
    buttonClassValue(newValue) {
      if (newValue === 1) {
        this.buttonValue.class = 'add-button align-left';
      } else if (newValue === 2) {
        this.buttonValue.class = 'add-button align-right';
      } else {
        this.buttonValue.class = 'add-button align-center';
      }
    },
  },
};
</script>
<style lang="scss">
.add-element-wrapper {
  .img-picker > .flex {
    .h-20.border-dashed,
    .h-20.border-dashed + .flex-grow,
    .h-20.border-dashed + .flex-grow + .flex {
      display: none;
    }
    & > button {
      width: 40px;
      height: 40px;
      opacity: 0;
      position: absolute;
      left: 0;
      top: 0;
      margin: 0;
      z-index: 10;
    }
  }
  .img-picker .border {
    border-color: #ddd;
  }
  .btn-toggle {
    border: 1px solid #ddd;
    color: #555;
  }
  .video-picker .video-iframe-edit > .cursor-pointer > svg {
    opacity: 0;
  }
  .video-picker .edit-icon {
    opacity: 0;
  }
  .img-picker {
    .my-4 {
      margin: 0px;
    }
    button#gp-styleEditor-chooseImage {
      background: transparent;
      box-shadow: none;
      border: none;
      width: 32px;
      font-size: 8px;
      color: transparent;
      &:hover,
      &:focus {
        background: transparent;
        box-shadow: none;
        border: none;
      }
    }
  }
}
.style-radio.light {
  .w-6 {
    border-color: #000;
  }
  .font-semibold {
    color: #000;
  }
}
.hidden-elements {
  .video-library-wrapper,
  .video-iframe-edit {
    > .cursor-pointer > svg {
      display: none;
    }
  }
}
.wistia-embed-wrapper {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  margin-top: 20px;
}
.wistia-embed-inner {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
</style>
